export default "__VITE_ASSET__fe979189__"